import type { InMemoryCacheConfig } from '@apollo/client'

import fragmentMatcher from '../../shared/@types/generated/backend/fragmentTypes.json'

export const inMemoryCacheOptions: InMemoryCacheConfig = {
  possibleTypes: fragmentMatcher.possibleTypes,
  typePolicies: {
    DefaultTeasersPayload: {
      keyFields: ['id', 'productType'],
    },
    DrawResultsPayload: {
      keyFields: ['drawDate', 'serialNumber'],
    },
    FixedCharge: {
      keyFields: false,
    },
    HighFrequency_Draw: {
      keyFields: ['participationId'],
    },
    HighFrequency_NextDraw: {
      keyFields: ['participationId'],
    },
    HighFrequency_OrderDetailsPayload: {
      keyFields: ['orderId'],
    },
    ImagePropertiesPayload: {
      keyFields: ['blurHash'],
    },
    VersionedConfig: {
      merge: true,
    },
  },
}
